/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { tenantsGetToken } from "../../funcs/tenantsGetToken.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  tenantId: z.string(),
};

export const tool$tenantsGetToken: ToolDefinition<typeof args> = {
  name: "tenants-get-token",
  description: `Get Tenant JWT Token

Returns a JWT token scoped to the tenant for safe browser API calls. Requires Admin API Key.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await tenantsGetToken(
      client,
      args.tenantId,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
